import {AppContext} from '@app/context/context';
import {hasAnyRole} from '@utils';
import {ReactNode, useContext} from 'react';
import {Navigate} from 'react-router-dom';

interface PermissionGateProps {
    roles?: string[]; // Какие роли должны быть, чтобы показать детей
    redirectTo?: string; // Куда перенаправлять, если нет нужных ролей
    children: ReactNode;
}

export const PermissionGate: React.FC<PermissionGateProps> = ({roles, redirectTo, children}) => {
    const {state} = useContext(AppContext);
    const user = state.user;

    // Если roles не указаны, показываем всем
    if (!roles || roles.length === 0) {
        return <>{children}</>;
    }

    // Если пользователь не имеет нужной роли:
    if (!hasAnyRole(user, roles)) {
        // Если есть redirectTo, то делаем редирект
        if (redirectTo) return <Navigate to={redirectTo} replace />;
        // Иначе просто скрываем UI
        return null;
    }

    // Иначе рендерим "детей"
    return <>{children}</>;
};
